import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=0a5a6b3a"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"
import style0 from "./Icon.vue?vue&type=style&index=0&id=0a5a6b3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports